import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {ajaxCall} from "./ServerFunctions";

export const fetchProgram = createAsyncThunk('program/fetch', async () => {
    const element = document.getElementById('program-list');
    const dataEventId = element?.getAttribute('data-event-id');

    // TODO: Uncomment this code if you want to use the ajaxCall function and fix it accordingly
    // const result = await ajaxCall({action: "program_list"})
    // if (result) {
    //     return result;
    // }

    const url = dataEventId ? `program/?event_id=${dataEventId}` : 'program';
    const {data} = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/${url}`,
        {
            headers: {
                'Content-Type': 'application/json',
                'Organization-Code': 'LIMMUD_BALTICS'
            },
        }
    );

    return data;
});
